/*eslint-disable no-unused-vars */
import { useRef, useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { frameColumnsForDocumentList } from '../../../utils/common';
import APIEndpoints from '../../../../Member/api/APIEndpoints'; //getDocumentUploadList
import { axiosInstance } from '../../../../api/axios';
import MasterPermissions from '../../../api/MasterPermissions';
//Third party packages
import debounce from 'lodash.debounce';
import useDate from '../../../utils/useDate';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  setSearchUserText,
  setRecordsPerPage,
  setPageNumber,
  resetUploadDocuments,
} from 'src/redux/member/uploadDocumentSlice';
import { setSearchParams } from 'src/redux/member/memberClaimsSlice';

const useViewAllDocuments = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { searchUserText, recordsPerPage, pageNumber } = useSelector(
    (state) => state.uploadDocument,
  );
  //The below one is Master List
  const [getDocumentData, setGetDocumentData] = useState([]);
  //FilteredList
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [totalfilteredRecords, setTotalFilteredRecords] = useState([]);
  //pagination specific states
  const [pageSize, setPageSize] = useState(recordsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  //search
  const [searchText, setSearchText] = useState(searchUserText);
  const [search, setSearch] = useState(searchUserText);
  //API
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [dataFetching, setDataFetching] = useState(false);
  const [loadingApiConfig, setLoadingApiConfig] = useState(true);

  const displayPaginationMininumCount = 10;
  const { formatDate } = useDate();

  const { loggedInUserOID, loggedInMemberType, employeeInfo, dependentsInfo } =
    useSelector((state) => state.memberSummary);

  const { userData } = useSelector((state) => state.user);

  const pageInfo = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  const pageSizeHandler = (pageSizeInfo) => {
    setPageSize(pageSizeInfo.value);
    setCurrentPage(1);
    dispatch(setSearchParams({ pageSize: pageSizeInfo.value }));
    dispatch(setSearchParams({ pageNumber: 1 }));
    recordsFilterHandler(totalfilteredRecords, pageSizeInfo.value, 1);
  };

  const paginationHandler = (page) => {
    setCurrentPage(page);
    dispatch(setSearchParams({ pageNumber: page }));
    recordsFilterHandler(totalfilteredRecords, pageSize, page);
  };

  const debouncedCall = useCallback(
    debounce(
      (currentVal) => (setSearchText(currentVal), setSearch(currentVal)),
      800,
    ),
    [],
  );

  const onSearch = (event) => {
    setCurrentPage(1);
    setSearchText(event.target.value);
    debouncedCall(event.target.value);
  };
  const getParams = () => {
    const entityType = userData.UserType.toUpperCase();
    const memberID = employeeInfo.MemberID;
    const memberSequenceNumber =
      entityType === 'EMPLOYEE'
        ? 0
        : dependentsInfo.filter(
            (item) => item.OID === userData.MemberDetails.MemberOID,
          )[0].MemberSeqID;

    return `/EntityType/${entityType}/EntityKey/${memberID},${memberSequenceNumber}`;
  };

  const documentDataList = async (resetPage = '') => {
    setLoadingApiConfig(true);
    const sortData = '/SortBy/sentDate/SortDirection/desc';
    const currentPageNumberLocal = resetPage ? 1 : pageNumber;
    const recordsPerPageLocal = resetPage ? 10 : recordsPerPage;
    const searchTextLocal = resetPage ? '' : searchUserText;
    console.log('getParams--@', getParams());
    try {
      const responseDocument = await axiosInstance.get(
        APIEndpoints.getDocumentUploadList() + getParams(),
      );
      const data = responseDocument?.data?.Response?.listOfDocumentUploadObj;
      const InternalPermission = MasterPermissions.CheckPermission(
        'View Internal Document',
      );
      const ExpternalPermission = MasterPermissions.CheckPermission(
        'View External Document',
      );
      const permissionFilteredData =
        InternalPermission && ExpternalPermission
          ? data
          : InternalPermission
          ? data.filter((item) => item.Source === 'JMP')
          : ExpternalPermission
          ? data.filter((item) => item.Source === 'JAVELINA')
          : [];
      const totalRecords = permissionFilteredData.length;
      setGetDocumentData(permissionFilteredData);
      setTotalRecords(totalRecords);
      frameDataToDisplay(permissionFilteredData);
      //setCurrentPage(pageNumber);
      //setFilteredRecords(documentListData);
      setDataFetching(false);
      setIsNotFound(false);
      setIsAPIFailed(false);
      setLoadingApiConfig(false);
    } catch (error) {
      setDataFetching(false);
      setIsAPIFailed(true);
      setLoadingApiConfig(false);
      if (error.toString().includes('404')) {
        setIsNotFound(true);
        setLoadingApiConfig(false);
      }
    }
  };

  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting || 'MM-DD-YYYY',
  );

  const columnNames = useMemo(() => {
    return frameColumnsForDocumentList(Default_Time_Format);
  }, [getDocumentData]);

  const getSendDocumentForFun = (memOid, depOid) => {
    let sendDocFor;
    if (depOid) {
      const filterOidData = dependentsInfo.filter(
        (item) => item.OID === depOid,
      );
      return (sendDocFor =
        filterOidData[0]?.FirstName + ' ' + filterOidData[0]?.LastName);
    } else if (memOid) {
      return (sendDocFor =
        employeeInfo?.FirstName + ' ' + employeeInfo?.LastName);
    }
  };

  const frameDataToDisplay = (docData) => {
    if (docData?.length > 0) {
      const records = [];
      const iterationCount = docData.length;
      for (let iIndex = 0; iIndex < iterationCount; iIndex++) {
        records.push({
          Title: docData[iIndex].Title,
          Type: docData[iIndex].EntityType,
          ReferenceNumber: docData[iIndex].ReferenceNumber,
          SentDate: docData[iIndex].SentDate,
          documents: `${docData[iIndex].TotalDocument + ' Documents'}`,
          Comment: docData[iIndex].Comment,
          senddocumentfor: getSendDocumentForFun(
            docData[iIndex].MemberOid,
            docData[iIndex].DependentOid,
          ),
          oid: docData[iIndex].Oid,
          LocationOid: docData[iIndex]?.LocationOid,
          DocumentControlNumber: docData[iIndex]?.DocumentControlNumber,
          FileName: docData[iIndex]?.FileName,
          Source: docData[iIndex]?.Source,
        });
      }
      //setFilteredRecords(records);
      setTotalFilteredRecords(records);
      recordsFilterHandler(records, pageSize, currentPage);
    } else {
      setFilteredRecords([]);
      setTotalFilteredRecords([]);
    }
  };

  const sortingDataHandler = (data) => {
    if (data?.length > 0) {
      const sortByTime = data?.slice()?.sort((a, b) => {
        return b?.date - a?.date;
      });
      const sortByPin = sortByTime
        ?.filter((p1) => p1.pin === true)
        .concat(sortByTime?.filter((p1) => p1.pin !== true));
      return sortByPin;
    } else {
      return [];
    }
  };

  const filterSearchRecords = () => {
    const requestTitleFilteredData = getDocumentData?.filter((item) =>
      item?.Title?.toLowerCase()?.includes(searchText.toLowerCase()),
    );

    const requestTypeFilteredData = getDocumentData?.filter((item) =>
      item?.EntityType?.toLowerCase()?.includes(searchText.toLowerCase()),
    );

    const requestDateFilteredData = getDocumentData?.filter((item) =>
      item?.SentDate?.toLowerCase()?.includes(searchText.toLowerCase()),
    );

    const finalFilteredData = new Set(
      sortingDataHandler([
        ...requestTitleFilteredData,
        ...requestTypeFilteredData,
        ...requestDateFilteredData,
      ]),
    );
    //setPageSize(10);
    setCurrentPage(1);
    setTotalRecords([...finalFilteredData].length);
    frameDataToDisplay([...finalFilteredData]);
  };

  useEffect(() => {
    if (
      (location?.state?.selfPage === undefined &&
        location?.state?.documentDetailBackButton === undefined) ||
      location?.state?.sendDocumentBackButton !== undefined
    ) {
      dispatch(resetUploadDocuments());
      dispatch(setPageNumber(1));
      dispatch(setRecordsPerPage(10));
      dispatch(setSearchUserText(''));
      setPageSize(10);
      setCurrentPage(1);
      setSearch('');
      setSearchText('');
      documentDataList('reset');
      location.state = {
        ...location.state,
        selfPage: true,
        sendDocumentBackButton: undefined,
      };
    } else {
      documentDataList();
    }
  }, [pageNumber, recordsPerPage]);

  useEffect(() => {
    getDocumentData && getDocumentData.length > 1 && filterSearchRecords();
  }, [search]);

  const {
    searchParms: { pageSize: pageSizeStore, pageNumber2, sortBy: sortByColumn },
  } = useSelector(({ memberClaims }) => memberClaims);

  const recordsFilterHandler = (masterDataList, pageSize, currentPage) => {
    const filteredData = [];
    masterDataList.forEach((eachItem, index) => {
      if (
        index >= pageSize * currentPage - pageSize &&
        index < pageSize * currentPage
      ) {
        filteredData.push(eachItem);
      }
    });

    setFilteredRecords(filteredData);
  };

  const sortHandler = (sortColumn, isDesending, claimData) => {
    const sortedData = [...claimData];
    if (sortColumn === 'SentDate') {
      if (isDesending) {
        sortedData.sort((a, b) => new Date(b.SentDate) - new Date(a.SentDate));
      } else {
        sortedData.sort((a, b) => new Date(a.SentDate) - new Date(b.SentDate));
      }
    } else {
      if (isDesending) {
        sortedData.sort((a, b) => {
          const fa = a[sortColumn].toLowerCase(),
            fb = b[sortColumn].toLowerCase();

          if (fa > fb) {
            return -1;
          }
          if (fa < fb) {
            return 1;
          }
          return 0;
        });
      } else {
        sortedData.sort((a, b) => {
          const fa = a[sortColumn].toLowerCase(),
            fb = b[sortColumn].toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      }
    }
    return sortedData;
  };

  const customSortingHandler = (sortColumn, isDesending, sortyByData) => {
    console.log(
      'debug_sortByColumn',
      sortByColumn,
      sortColumn,
      isDesending,
      sortyByData,
    );
    if (
      sortByColumn[0].id !== sortColumn ||
      sortByColumn[0].desc !== isDesending ||
      sortByColumn[0].id === 'ServiceDate'
    ) {
      const customSortData = sortHandler(
        sortColumn,
        isDesending,
        totalfilteredRecords,
      );
      //setRecordsToDisplay(customSortData);
      setTotalFilteredRecords(customSortData);
      dispatch(
        setSearchParams({
          sortBy: [
            sortByColumn[0].id === 'ServiceDate'
              ? columnNames[2]
              : sortyByData[0],
          ],
        }),
      );
      recordsFilterHandler(customSortData, pageSize, currentPage);
    }
  };

  return {
    pageInfo,
    filteredRecords,
    pageSize,
    currentPage,
    totalRecords,
    searchText,
    columnNames,
    displayPaginationMininumCount,
    isNotFound,
    loadingApiConfig,
    isAPIFailed,
    setFilteredRecords,
    setPageSize,
    setCurrentPage,
    setTotalRecords,
    setSearchText,
    pageSizeHandler,
    paginationHandler,
    onSearch,
    customSortingHandler,
    recordsFilterHandler,
  };
};

export default useViewAllDocuments;
